<app-loading></app-loading>
<app-header></app-header>
<div class="app-shell__content">
  <router-outlet></router-outlet>
</div>
<app-warning-toast></app-warning-toast>
<app-error-modal></app-error-modal>
<app-info-modal></app-info-modal>
<app-refresh-token-modal></app-refresh-token-modal>
<app-unsubscribe></app-unsubscribe>
<app-quiz-modal></app-quiz-modal>
